export default ({ title }: HeaderTitleProps) => (
  <h1 className='f2 mb5 tc w-100 lh-headline b'>
    {title}
  </h1>
)

interface HeaderTitleProps {
  title: string;
}
